var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9811 23.6667C18.4244 23.6667 23.6478 18.4434 23.6478 12C23.6478 5.55672 18.4244 0.333374 11.9811 0.333374C5.5378 0.333374 0.314453 5.55672 0.314453 12C0.314453 18.4434 5.5378 23.6667 11.9811 23.6667ZM11.9811 21.3334C17.1358 21.3334 21.3145 17.1547 21.3145 12C21.3145 6.84538 17.1358 2.66671 11.9811 2.66671C6.82646 2.66671 2.64779 6.84538 2.64779 12C2.64779 17.1547 6.82646 21.3334 11.9811 21.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8145 8.50004C18.2701 8.95565 18.2701 9.69434 17.8145 10.15L10.8145 17.15C10.5847 17.3797 10.2695 17.5033 9.94472 17.4908C9.61999 17.4783 9.31518 17.331 9.1037 17.0843L5.6037 13.0009C5.18437 12.5117 5.24103 11.7752 5.73024 11.3559C6.21945 10.9365 6.95597 10.9932 7.37529 11.4824L10.0554 14.6092L16.1645 8.50004C16.6201 8.04443 17.3588 8.04443 17.8145 8.50004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutline);
export default __webpack_public_path__ + "static/media/checkmark-outline.7600b966df7eb7d2b9707e75db33e389.svg";
export { ForwardRef as ReactComponent };